import React from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ownerApi, inr, monthLabel } from "@/lib/ownerApi";

const LABEL = { matched_excel: "Already in Excel (same student, month & amount)", partly_excel: "Partly in Excel",
  review: "Annual-batch receipt — Excel has no dates", new: "New payment, counted from the app" };

export default function ReceiptCheck({ r, onChange }) {
  if (!r) return null;
  const decide = async (cid, decision) => {
    try { await ownerApi.post(`/fin/receipts/${cid}/decision`, { decision }); toast.success("Saved"); onChange(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <section className="rounded-2xl border border-stone-200 bg-white p-4 space-y-3" data-testid="receipt-check">
      <h3 className="font-bold text-stone-900">Live receipts check — each counted exactly once</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
        {Object.entries(LABEL).map(([k, l]) => (
          <div key={k} className="rounded-lg border p-2" data-testid={`receipt-sum-${k}`}>{l}
            <b className="block">{r.summary[k]?.count || 0} receipts · {inr(r.summary[k]?.amount || 0)}</b>
            <span className="text-xs text-stone-500">counted from app {inr(r.summary[k]?.counted || 0)}</span></div>))}
      </div>
      <p className="text-xs text-stone-600" data-testid="receipt-total">All approved receipts {inr(r.total)} · added to collections from the app {inr(r.counted)} · the rest is already inside the Excel figures.</p>
      {r.needs_decision.length > 0 && (
        <div className="space-y-2" data-testid="receipt-needs-decision">
          <p className="text-sm font-semibold text-amber-800">{r.needs_decision.length} receipt(s) need your decision. Until you decide they are counted as new payments.</p>
          {r.needs_decision.map((i) => (
            <div key={i.collection_id} className="rounded-lg border border-amber-200 bg-amber-50 p-2 text-sm flex flex-wrap items-center gap-2" data-testid={`receipt-${i.collection_id}`}>
              <b className="capitalize">{i.name}</b> {i.roll_number} · receipt {i.receipt_no || "—"} · {monthLabel(i.month)} · {inr(i.amount)} ({i.mode})
              <span className="text-xs text-stone-600">Excel: {i.excel_rows.join(", ")}{i.excel_outstanding != null ? ` · Excel outstanding ${inr(i.excel_outstanding)}` : ""}{i.in_excel ? ` · ${inr(i.in_excel)} found in Excel` : ""}</span>
              <span className="flex gap-1 ml-auto">
                <Button size="sm" variant="outline" onClick={() => decide(i.collection_id, "in_excel")} data-testid={`receipt-in-excel-${i.collection_id}`}>Already in Excel</Button>
                <Button size="sm" className="bg-emerald-800 hover:bg-emerald-900" onClick={() => decide(i.collection_id, "new")} data-testid={`receipt-new-${i.collection_id}`}>New payment</Button>
              </span>
            </div>))}
        </div>)}
      <details className="text-xs"><summary className="cursor-pointer font-semibold">All receipts ({r.items.length})</summary>
        <ul className="mt-1 space-y-0.5">{r.items.map((i) => <li key={i.collection_id}>{i.receipt_no || "—"} · <span className="capitalize">{i.name}</span> {i.roll_number} · {monthLabel(i.month)} · {inr(i.amount)} → {LABEL[i.status]}{i.excel_match.length ? ` (${i.excel_match.join(", ")})` : ""}{i.decision ? ` · your decision: ${i.decision === "in_excel" ? "already in Excel" : "new"}` : ""}</li>)}</ul>
      </details>
    </section>
  );
}
